// mui
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const RootStyles = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.neutral,
}));


export default function OfferStopByCompany() {

  return (
    <RootStyles>
      <Typography variant="body2">
        회사 사정으로 매칭이 중단되었습니다.
      </Typography>
    </RootStyles>
  )
}
